import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeIconModule, seFeIconSpotId } from 'se-fe-icon'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFePopoverModule } from 'se-fe-popover'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { SharedUiContactInfoModule } from '@se-po/shared-ui-contact-info'
import { SharedUiDobSelectModule } from '@se-po/shared-ui-dob-select'
import { SharedUiGenderSelectModule } from '@se-po/shared-ui-gender-select'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'
import { SharedUiNameModule } from '@se-po/shared-ui-name'
import { SharedUiSetupBarModule } from '@se-po/shared-ui-setup-bar'

import { SelfInfoComponent } from './self-info/self-info.component'
import { SharedUiPersonaInfoModule } from '@se-po/shared-ui-persona-info'

@NgModule({
  declarations: [SelfInfoComponent],
  exports: [SelfInfoComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeIconModule.include([seFeIconSpotId]),
    SeFeLinkModule,
    SeFePopoverModule,
    SeFeSpinnerModule,
    SharedUiContactInfoModule,
    SharedUiDobSelectModule,
    SharedUiGenderSelectModule,
    SharedUiHighlightLabelModule,
    SharedUiNameModule,
    SharedUiPersonaInfoModule,
    SharedUiSetupBarModule,
  ],
})
export class SeHouseholdSetupFeatureSelfInfoModule {}
